<template lang="pug">
v-container.py-15
  custom-title.text-center.mb-8 Produtos
  carousel.mb-6.page-home-products(
    v-if="brands.length",
    :nav="false",
    :margin="10",
    :responsive="brandsCarouselResponsive"
  )
    brand-card(
      v-for="({ id, img, title, to }, i) in brands",
      :key="i",
      :to="'/produtos?b=' + id",
      :img="img",
      :title="title"
    )
  .mb-4.d-flex.justify-center.flex-wrap
    v-chip.mr-2.text-body-1.py-4.mb-4(
      v-for="({ id, title }, i) in categories",
      :to="'/produtos?c=' + id",
      :key="i",
      outlined
    ) {{ title }}
  template(v-if="!loading")
    div
      grid-container.justify-start(
        cols="auto",
        cols-sm="repeat(2, calc((100% - 20px) / 2))",
        cols-md="repeat(3, calc((100% - 40px) / 3))",
        cols-lg="repeat(4, calc((100% - 60px) / 4))",
        cols-xl="repeat(5, calc((100% - 80px) / 5))"
      )
        product-card(
          v-for="({ img, title, to }, i) in products",
          :key="i",
          :img="img",
          :title="title",
          :to="to"
        )
    .d-flex.justify-center
      v-btn.mt-8.px-10(to="/produtos", color="primary", tile, outlined, large) VER TODOS
  .py-10.d-flex.justify-center(v-else)
    v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle.vue";
import ProductCard from "@/components/cards/Product";
import BrandCard from "@/components/cards/Brand";
import carousel from "vue-owl-carousel";
import { formatToURL } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    products: [],
  }),
  computed: {
    brands() {
      return this.$rest("brands").list.map(({ id, img, title }) => ({
        id,
        img: img ? this.files + "/" + img : "",
        title,
        to: `/produtos?b=${id}`,
      }));
    },
    brandsCarouselResponsive() {
      return {
        0: { items: 2 },
        300: { items: 3 },
        600: { items: 6 },
        1200: { items: 9 },
      };
    },
    categories() {
      return this.$rest("categories").list;
    },
    thresholds() {
      return this.$vuetify.breakpoint.thresholds;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    itemsPerPage() {
      if (this.xsOnly) {
        return 4;
      } else if (this.sm) {
        return 6;
      } else {
        return 8;
      }
    },
  },
  beforeCreate() {
    this.$rest("brands").get();
    this.$rest("categories").get();
  },
  created() {
    this.$rest("products").get({
      params: {
        itemsPerPage: this.itemsPerPage,
        featured: 1,
      },
      save: (state, list) => {
        this.products = list.map(({ id, img, title }) => ({
          img: img ? this.files + "/" + img : "",
          title,
          to: `/produtos/${formatToURL(`${title}-${id}`)}`,
        }));
        this.loading = false;
      },
    });
  },
  components: {
    CustomTitle,
    ProductCard,
    BrandCard,
    carousel,
  },
};
</script>

<style>
.page-home-products .owl-stage {
  margin: 0 auto !important;
}
</style>
